"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceAreaApi = void 0;
var light_data_store_1 = __importDefault(require("../../Data/light-data-store"));
var data_entity_1 = require("../../data-entity");
var data_store_1 = __importDefault(require("../../data-store"));
var storable_data_service_1 = __importDefault(require("../../storable-data-service"));
var service_area_consts_1 = require("./service-area.consts");
var service_area_service_1 = __importDefault(require("./service-area-service"));
var ServiceAreaApi = /** @class */ (function () {
    function ServiceAreaApi(session) {
        var groupFilters = [
            {
                groupType: service_area_consts_1.ServiceAreaFilterGroups.Teams,
                keyFunc: function (serviceArea) { return serviceArea.team_ids; }
            }
        ];
        this.serviceAreaStore = new data_store_1.default(groupFilters);
        this.serviceAreaService = new service_area_service_1.default(session);
        var lightDataStore = new light_data_store_1.default();
        this.storableDataService = new storable_data_service_1.default(this.serviceAreaStore, undefined, [lightDataStore]);
    }
    ServiceAreaApi.prototype.loadAll = function (options) {
        var _this = this;
        return this.storableDataService.loadAll('loadAll', function () { return _this.serviceAreaService.loadAll(options); }, options);
    };
    ServiceAreaApi.prototype.create = function (request) {
        var _this = this;
        return this.storableDataService.modify('create', function () { return _this.serviceAreaService.create(request); });
    };
    ServiceAreaApi.prototype.update = function (id, request) {
        var _this = this;
        return this.storableDataService.modify('update', function () { return _this.serviceAreaService.update(id, request); });
    };
    ServiceAreaApi.prototype.delete = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.storableDataService.delete('delete', function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.serviceAreaService.delete(id)];
                                    case 1:
                                        response = _a.sent();
                                        return [2 /*return*/, response];
                                }
                            });
                        }); }, id)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ServiceAreaApi.prototype.loadAllByTeams = function (request, options) {
        if (options === void 0) { options = data_entity_1.DEFAULT_OPTIONS; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.storableDataService.loadAll('loadAllByTeams', function (teams_ids) { return _this.serviceAreaService.loadAllByTeams(__assign(__assign({}, request), { teams_ids: teams_ids }), options); }, __assign(__assign({}, options), { groupType: service_area_consts_1.ServiceAreaFilterGroups.Teams, groupValue: request.teams_ids }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ServiceAreaApi.prototype.assign = function (id, userId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.serviceAreaService.assign(id, userId)];
            });
        });
    };
    ServiceAreaApi.prototype.unassignUser = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.serviceAreaService.unassign(userId)];
            });
        });
    };
    ServiceAreaApi.prototype.get = function (id) {
        return this.serviceAreaStore.get(id);
    };
    ServiceAreaApi.prototype.getByIds = function (ids) {
        var _this = this;
        return ids.map(function (id) { return _this.get(id); });
    };
    ServiceAreaApi.prototype.getAll = function () {
        return this.serviceAreaStore.getAll();
    };
    ServiceAreaApi.prototype.removeAll = function () {
        this.serviceAreaStore.removeAll();
    };
    ServiceAreaApi.prototype.getGroup = function (group, groupValue) {
        return this.serviceAreaStore.getGroup(group, groupValue);
    };
    ServiceAreaApi.prototype.loadAllByTeamsAndFields = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.storableDataService.loadAll('loadByFields', function () { return __awaiter(_this, void 0, void 0, function () {
                        var res;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.serviceAreaService.getAllByFields(request)];
                                case 1:
                                    res = _a.sent();
                                    return [2 /*return*/, res.success ? res.service_areas : []];
                            }
                        });
                    }); }, { useCache: true, fields: request.fields })];
            });
        });
    };
    return ServiceAreaApi;
}());
exports.ServiceAreaApi = ServiceAreaApi;
//# sourceMappingURL=service-area-api.js.map